'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = time;
var pad = function pad(num) {
  return ('0' + num).slice(-2);
};

/**
 * Time plugin.
 *
 * @param {String} msgs Messages.
 * @param {Object} options Plugins options.
 * @param {Object} level Level.
 * @param {String} level.name Level name.
 * @param {Object} level.options Level options.
 *
 * @returns {Object} Plugin result.
 */
function time(msgs, options, level) {
  var date = new Date();

  var hours = pad(date.getHours());
  var minutes = pad(date.getMinutes());
  var seconds = pad(date.getSeconds());

  var time = hours + ':' + minutes + ':' + seconds;

  var formattedMsg = '[' + time + ']';

  return { before: formattedMsg };
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/quark-log/lib/plugins/time.js
// module id = 224
// module chunks = 1